import React from "react";
import { Wrapper } from "./WhyUsButtonMobile.style";
const WhyUsButtonMobile = ({
  title,
  background,
  setColor,
  setReverseColor,
  close,
  last,
  onClick,
  index,
}) => {
  return (
    <Wrapper
      style={{ backgroundImage: `url(${background})` }}
      setColor={setColor}
      setReverseColor={setReverseColor}
      onClick={onClick}
      last={last}
      close={close}
      index={index}
    >
      <span className={`buttontitle ${close ? "close" : null}`}>
        <span className="rotated">{title}</span>
      </span>
    </Wrapper>
  );
};

export default WhyUsButtonMobile;
